import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 bg-slate-50 p-6 text-center">
      <h1 className="text-lg font-semibold text-slate-900">Page not found</h1>
      <Link to="/" className="text-sm text-blue-700 hover:underline">
        Back to accounts
      </Link>
    </div>
  );
}
